const loadGoogleMapsApi = require('load-google-maps-api');
	
document.addEventListener('DOMContentLoaded', function() {
    
    var el = document.getElementById('offermap');
    
    const initMap = function() {
        var overlay;
    
    	var markers = [],
    		map, 
    		initialized = false,
    		locations = [],
    		markerHeight = 34,
    		markerWidth = 30,
    		mydata = [],
    		mapItems = [],
    		bounds,
    		mapItems = [],
    		mapItemsUrl = el.dataset.json;
    		mapStyle = [{"featureType":"all","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"color":"#444444"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#ff0000"},{"saturation":"-15"},{"lightness":"40"},{"gamma":"1.25"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#ff0000"},{"lightness":"80"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#efefef"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}],
    		tooltip = '',
    		tooltipStatus = false;
    
    
        function fromLatLngToPoint(latLng, map) {
            var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
            var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
            var scale = Math.pow(2, map.getZoom());
            var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
            return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
        }
    
        const addMarkers = function() {
            
            let event = 'click';
            
            if (!("ontouchstart" in document.documentElement)) {
                event = 'mouseover';
    //            document.documentElement.className += " no-touch";
            }
            
            for (let i = 0; i < mydata.length; i++) {
    
                let coords = mydata[i].coordinates,
                    img = mydata[i].img,
                    markerType = mydata[i].type,
                    position = new google.maps.LatLng(coords[0], coords[1]),
                    title = mydata[i].title,
                    url = mydata[i].url;
                
                if (markerType === 'flats') {
                    markerUrl = el.getAttribute('data-marker-flats')
                } else {
                    markerUrl = el.getAttribute('data-marker-houses')
                }
    
                let image = {
    				url: markerUrl,
    				size: new google.maps.Size(markerWidth, markerHeight),
    			}
    
                let marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: 'Hello',
                    icon: image,
    				animation: google.maps.Animation.DROP,
                });
                bounds.extend(position);
                
                google.maps.event.addListener(marker, event, function () {
                    var point = fromLatLngToPoint(marker.getPosition(), map);
                    
                    removeTooltip();
                    
                    tooltip = document.createElement("div");
                    tooltip.className = "c-offermap__tooltip";
                    tooltip.style.top = point.y + 'px';
                        
                    tooltip_inside = document.createElement("figure");
                    tooltip_inside.innerHTML = '<img src="'+img+'" alt=""><figcaption><div class="title">'+title+'</div><p><a href="'+url+'" class="o-btn o-btn--minor">Zobacz więcej</a></p></figcaption>';
                    
                    tooltip.appendChild(tooltip_inside);
                    el.appendChild(tooltip);
                    tooltipStatus = true;
                    
                    tooltip.style.left = point.x  - tooltip.clientWidth/2 + 'px';
                    
                    setTimeout(function() {
                        tooltip.classList.add('is-visible');
                    }, 1);
                    
                    tooltip.addEventListener('mouseleave', function () {
                        el.removeChild(tooltip);
                    });
                });
            }
    	};
    	
    	const loadData = function(arg) {
        	mydata = JSON.parse(arg);                           
            init();
        }
    
        const loadDataFromFile = function(arg) {
            
            if (window.location.protocol != 'file:') {
                    
                let request = new XMLHttpRequest();
                
                request.open('GET', arg, true);
                request.send(null);
                
                request.onreadystatechange = function() {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                                                
                            console.log('map items loaded:');
                            
                            mydata = JSON.parse(request.responseText);                           
                            
                            console.log(mydata);
                            
                            init();
        
                        } else {
                            console.log(request.status, request.statusText);
                        }
                    }
                };
                
            } else {
                
                init();
                
            }
        };
        
        const centerMapWithMarkers = function() {
            
            // zmniejszamy przybliżenie
            let minDistance = 0.00198,
                sumA = bounds.getNorthEast().lng() - bounds.getSouthWest().lng(),
                sumB = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();
            if ((sumA < minDistance && sumA > -minDistance) && (sumB < minDistance && sumB > -minDistance)) {
                var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + minDistance, bounds.getNorthEast().lng() + minDistance),
                    extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - minDistance, bounds.getNorthEast().lng() - minDistance);
                bounds.extend(extendPoint1);
                bounds.extend(extendPoint2);
            }
            
            // center map to markers 
    		map.fitBounds(bounds);
        };
    
    	const getLocations = function(map) {
    
            bounds = new google.maps.LatLngBounds();
            
    //        loadData();
    //        loadDataFromFile();
            addMarkers();
            centerMapWithMarkers();       
    
    	};
    	
    	const openUrl = function() {	
    		window.location.href = this.url;
    	}
    
        const removeTooltip = function() {
            if (("ontouchstart" in document.documentElement)) {
                if(tooltip) {
                    if (tooltipStatus === true) {
                        el.removeChild(tooltip);
                        tooltipStatus = false;
                    }
                }
            }
        }
    
    	const init = function() {
        	console.log('map init');
    
        	loadGoogleMapsApi({
                key: 'AIzaSyAtmyxhfag5M7TeoTEJMZvKdHEUaT4gkjs'
            }).then(function (googleMaps) {
                map = new google.maps.Map(el, {
                    center: {
                        lat: 40.7484405,
                        lng: -73.9944191
                    },
                    disableDefaultUI: true,
                    styles: mapStyle,
                    zoom: 12
                })
                
                map.addListener('center_changed', function () {
                    removeTooltip();
                });
                
                getLocations(map);
                
            }).catch(function (error) {
                console.error(error)
            });
            
            
    	};
    	
    	//loadDataFromFile(mapItemsUrl);
    	loadData(mapItemsUrl);
    }


	el ? initMap() : false;
    	

}, false);
